import { ILocationData } from 'meta/pages/v4/location'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  idOrCodeUrl: string
}

type Response = ILocationData

export const getData = async (props: Props): Promise<Response> => {
  const { idOrCodeUrl } = props

  const endpoint = ApiEndpoint.v4.location.data(idOrCodeUrl)

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)

  return data
}
